<!--教科研-->
<template>
    <div class="container">
        <div class="wel-box">
            <div class="course-container">
                <div class="left-menu-container">
                    <div class="menu-container">
                        <div @click="changeItem('1','0')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">
                            课题引领
                        </div>
                        <div v-if="activeItem==='1'" class="child-menu-container">
                            <div @click="changeItem('1','1')" class="chile-item-container">
                                <div :class="activeChildItem==='1'?'child-menu-item child-menu-active':'child-menu-item'">
                                    进行中
                                </div>
                            </div>
                            <div @click="changeItem('1','2')" class="chile-item-container">
                                <div :class="activeChildItem==='2'?'child-menu-item child-menu-active':'child-menu-item'">
                                    已结束
                                </div>
                            </div>
                            <div @click="changeItem('1','3')" class="chile-item-container">
                                <div :class="activeChildItem==='3'?'child-menu-item child-menu-active':'child-menu-item'">
                                    已发布
                                </div>
                            </div>
                        </div>
                        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">
                            教研赛事
                        </div>
                        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">
                            专题活动
                        </div>
                        <div @click="changeItem('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">
                            成果展示
                        </div>
                    </div>
                </div>
                <!-- 课题引领 -->
                <div v-if="activeItem==='1'"  class="right-content-container">
                    <app-page-topic :course-mode="this.activeMode"
                                :filter-item="this.activeChildItem"
                                     @change-mode="changeMode"/>
                </div>

                <div v-if="activeItem==='2'"  class="right-content-container">
                    <app-page-race :course-mode="this.activeMode"
                                @change-mode="changeMode"/>
                </div>
                <div v-if="activeItem==='3'"  class="right-content-container">
                    <app-page-activity :course-mode="this.activeMode"
                                    @change-mode="changeMode"/>
                </div>
                <div v-if="activeItem==='4'"  class="right-content-container">
                    <app-page-achieve :course-mode="this.activeMode"
                                   @change-mode="changeMode"/>
                </div>


            </div>
        </div>
    </div>
</template>
<script>
import {timestampToTime} from "@/utils/date";
import dataEmpty from "@/components/dataEmpty.vue";
import {userLoginVerify} from "@/api/user/login";

import appPageTopic from "@/components/app/tea/appPageTopic.vue";
import appPageRace from "@/components/app/tea/appPageRace.vue";
import appPageActivity from "@/components/app/tea/appPageActivity.vue";
import appPageAchieve from "@/components/app/tea/appPageAchieve.vue";

export default {
    components: {
        dataEmpty,

        appPageTopic,
        appPageRace,
        appPageActivity,
        appPageAchieve
    },
    name: "homeTeachResearch",
    data() {
        return {
            pageMode:"page",
            detailMode:"detail",
            timestampToTime,
            activePath: "homeTeachResearch",
            activeItem:"1",
            activeChildItem:"0",
            activeMode:"page",
        }
    },
    computed: {},
    watch: {},
    created() {
        if (this.$route.query.userId) {
            this.loginVerify(this.$route.query.userId)
        }
    },
    mounted() {

    },
    methods: {
        loginVerify(userId){
            userLoginVerify({ userId: userId }).then(res => {
                if (res.data.code === 1) {
                    const info = res.data.data;
                    this.$storage.set("userInfo", JSON.stringify(info.userInfo));
                    this.$storage.set("token", info.token);
                    this.$storage.set("role", info.role+'');
                    this.$storage.set("isAnalyse",info.isAnalyse+'');
                    this.$storage.set("isLogin", true);
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        changeItem(item,childItem){
            this.activeItem = item;
            this.activeChildItem = childItem;
            this.activeMode = this.pageMode;
            this.$store.commit("params/setJumpParams", {});
        },
        changeMode(mode){
            this.activeMode = mode;
        }
    }
}
</script>
<style scoped>
.container {
    width: 100%;
    height: 100%;
    margin: 0;
    overflow-y: auto!important;
    overflow-x: hidden;
    background-color: #f1f1f1;
}
.wel-box {
    width:100vw;
    height: auto;
    overflow-y: auto!important;
    .top-box{
        display: flex;
        width: 100vw;
        height: 70px;
        background: #ff7f2e;
    }
}
.course-container{
    width: 100%;
    height: auto;
    border: 10px;
    box-sizing: border-box;
    display: flex;
}
.left-menu-container{
    width: 200px;
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
.menu-container{
    height: calc(100vh - 50px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
    width: 180px!important;
    position: fixed;
    z-index: 999;
}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #ff7f2e;
    color: #fff;
    //font-weight: bold;
}

.child-menu-container{
    width: 100%;
    height: auto;
}
.chile-item-container{
    width: 100px;
    height: 34px;
    padding: 4px 0 4px 30px;
    box-sizing: border-box;
    cursor: pointer;
}
.child-menu-item{
    width: auto;
    height: 26px;
    line-height: 26px;
    border-radius: 6px;
    text-align: center;
    font-size: 14px;
}

.child-menu-active{
    background: #ff7f2e;
    color: #fff;
}
.right-content-container{
    width: calc(100% - 200px);
    height: auto;
    padding: 10px;
    box-sizing: border-box;
}
</style>